module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"errorState":"En erreur","draftState":"Brouillon non validé"},"en":{"errorState":"Error status","draftState":"Draft not validated"}}')
  delete Component.options._Ctor
}
